import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, unref as _unref, createTextVNode as _createTextVNode, withKeys as _withKeys, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "text-h3 text-sm-h2 font-weight-medium sz-primary-grey--text text-center" }
const _hoisted_2 = { class: "f-18 font-weight-medium sz-primary-grey--text text-center mb-0" }
const _hoisted_3 = { class: "text-h3 text-md-h2 font-weight-medium sz-primary-grey--text mb-2" }
const _hoisted_4 = { class: "f-16 font-weight-bold sz-secondary-grey--text mb-0" }
const _hoisted_5 = { class: "text-h3 text-md-h2 font-weight-medium sz-primary-grey--text mb-0" }
const _hoisted_6 = { class: "mt-6 d-flex justify-space-evenly flex-wrap align-end" }
const _hoisted_7 = { class: "w-100" }
const _hoisted_8 = { class: "mb-2 pt-5 sz-primary-grey--text f-24 font-weight-medium" }
const _hoisted_9 = {
  key: 0,
  class: "mb-0 d-inline-block ml-3 sz-red--text font-weight-medium f-16"
}

import HomeHero from '@/components/Home/HomeHero.vue';
import InfoSectionHome from '@/components/Home/InfoSection/InfoSectionHome.vue';
import SzBubble from '@/components/Home/SzBubble.vue';
import BannerBox from '@/components/widgets/BannerBox/BannerBox.vue';
import BaseButton from '@/components/widgets/BaseButton.vue';
import DonorSteps from '@/components/widgets/DonorSteps.vue';
import FAQPanels from '@/components/widgets/FAQPanels.vue';
import FooterComponent from '@/components/widgets/FooterComponent.vue';
import InfoBox from '@/components/widgets/InfoBox.vue';
import TextField from '@/components/widgets/Inputs/TextField.vue';
import LoaderComponent from '@/components/widgets/LoaderComponent.vue';
import ModalCustom from '@/components/widgets/ModalCustom.vue';
import ScrollTopButton from '@/components/widgets/ScrollTopButton.vue';
import SlidersContainer from '@/components/widgets/SlidersContainer.vue';
import SponsorsComponent from '@/components/widgets/SponsorsComponent.vue';
import { LINKS } from '@/constants/externalLinks';
import { HOME_PAGE_FAQ, HOME_PAGE_MOBILE_FAQ } from '@/constants/faq';
import { createSelectedProvinceEvent } from '@/plugins/gtm/events';
import { useGtm } from '@gtm-support/vue-gtm';
import { isMobile } from 'is-mobile';
import { useForm } from 'vee-validate';
import { computed, nextTick, ref, watch } from 'vue';
import { useGoTo } from 'vuetify';
import { useStore } from 'vuex';
import { storeToRefs } from 'pinia';
import useEditionStageStore from '@/stores/EditionStage';
import Http from '@/services/http';
import { useI18n } from 'vue-i18n';
import apiResource from '@/services/http/api/resource.ts';
import router from '@/router';
import ROUTE_NAMES from '@/constants/routeNames';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const goTo = useGoTo();
const store = useStore();
const gtm = useGtm();

const { t, tm } = useI18n();

store.commit('bubbles/clear');
store.commit('provinces/clear');

const editionStageStore = useEditionStageStore();

const {
    isBeforeCampaign,
    isAfterCampaign,
    isCampaignUnderway,
    passwordPopup
} = storeToRefs(editionStageStore);

const provincesLoader = computed(() => store.getters['provinces/getLoader']);

const bubblesList = computed(() => {
    const bubbles = store.getters['bubbles/getBubbles'] ?? [];
    return bubbles.filter(bubble => !!bubble?.name && !!bubble?.bubble_id);
});

const otherBubbles = computed(() => bubblesList.value.filter(el => !el.is_difficult));

const currentProvinceName = computed(() => store.getters['provinces/getCurrentProvinceName']);

const homePageFaq = computed(() => isMobile() ? HOME_PAGE_MOBILE_FAQ : HOME_PAGE_FAQ);

const difficultBubbles = computed(() => bubblesList.value.filter(el => el.is_difficult));

const bubblesLoader = computed(() => store.getters['bubbles/getLoader']);

watch(bubblesLoader, async (val) => {
    if (val === false) {
        await nextTick();
        goTo('#list', {
            offset: 48,
            easing: 'easeInQuad'
        });
    }
});

watch(currentProvinceName, (val) => {
    if (gtm) gtm.trackEvent(createSelectedProvinceEvent(val));
});

function initProvinces () {
    if (isCampaignUnderway.value) {
        store.dispatch('provinces/getFamiliesAmount');
        store.dispatch('provinces/getProvinces');
    } else {
        store.commit('provinces/setLoader', false);
    }
}

initProvinces();

useForm();
const password = ref<string>('');
const showPasswordErrorText = ref<boolean>(false);
const submitPasswordButtonDisabled = ref<boolean>(false);
const securePasswordValid = ref<boolean>(false);

const submitPassword = (): void => {
    submitPasswordButtonDisabled.value = true;
    Http.addSecureHeader(password.value);

    apiResource.getProvinces().then(() => {
        securePasswordValid.value = true;
    }).catch(() => {

    }).finally(() => {
        submitPasswordButtonDisabled.value = false;
    });
};
const hidePasswordErrorText = (): void => {
    showPasswordErrorText.value = false;
};
if (passwordPopup) {
    watch(securePasswordValid, (isSecurePasswordValid) => {
        if (isSecurePasswordValid) {
            editionStageStore.setEditionStageOpen();
            initProvinces();
            passwordPopup.value = false;
            router.push({
                name: ROUTE_NAMES.HOME
            });
        } else {
            showPasswordErrorText.value = true;
            submitPasswordButtonDisabled.value = false;
        }
    });
}

function getFamilyListRoute (bubble) {
    return {
        name: ROUTE_NAMES.FAMILIES_LIST,
        params: {
            bubbleId: bubble?.bubble_id,
            ga: {
                familyWarehouse: bubble?.name,
                provinceId: bubble?.province?.province_id,
                provinceName: bubble?.province?.name
            }
        }
    };
}

function scrollTop () {
    goTo('body', {
        easing: 'easeInQuad'
    });
}


return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_main = _resolveComponent("v-main")!

  return (!provincesLoader.value)
    ? (_openBlock(), _createBlock(_component_v_main, {
        key: 0,
        class: "home-page"
      }, {
        default: _withCtx(() => [
          _createVNode(HomeHero, {
            class: "mb-12",
            "show-scroll-down": !currentProvinceName.value
          }, null, 8, ["show-scroll-down"]),
          (bubblesLoader.value !== null)
            ? (_openBlock(), _createBlock(_component_v_container, {
                key: 0,
                id: "list",
                class: "pt-0"
              }, {
                default: _withCtx(() => [
                  (bubblesLoader.value === false && bubblesList.value?.length > 0)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "mb-12 sz-primary-background py-4"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('home.province')) + " " + _toDisplayString(currentProvinceName.value), 1),
                              _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('home.choose_where')), 1)
                            ]),
                            _: 1
                          }),
                          (difficultBubbles.value.length > 0)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "12",
                                class: "mb-12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('home.missing_donors')), 1),
                                          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('home.missing_donors_details')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(difficultBubbles.value, (bubble, index) => {
                                                return (_openBlock(), _createBlock(_component_v_col, {
                                                  key: index,
                                                  cols: "12",
                                                  sm: "6",
                                                  class: _normalizeClass(["d-flex justify-center", [(index % 2 === 0) ? 'pr-sm-3' : 'pl-sm-3', 'mt-5']])
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(SzBubble, {
                                                      name: bubble.name,
                                                      link: getFamilyListRoute(bubble),
                                                      highlighted: true
                                                    }, null, 8, ["name", "link"])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["class"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (difficultBubbles.value.length > 0 && otherBubbles.value.length > 0)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 1,
                                cols: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_divider, { class: "mb-12 d-block" })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (otherBubbles.value.length > 0)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 2,
                                cols: "12",
                                class: "mb-12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      (difficultBubbles.value.length > 0)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 0,
                                            cols: "12"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('home.other_locations')), 1)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: _normalizeClass({ 'mt-n5': difficultBubbles.value.length <= 0 })
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherBubbles.value, (bubble, index) => {
                                                return (_openBlock(), _createBlock(_component_v_col, {
                                                  key: index,
                                                  cols: "12",
                                                  sm: "6",
                                                  class: _normalizeClass(["d-flex justify-center", [(index % 2 === 0) ? 'pr-sm-3' : 'pl-sm-3', 'mt-5']])
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(SzBubble, {
                                                      name: bubble.name,
                                                      link: getFamilyListRoute(bubble)
                                                    }, null, 8, ["name", "link"])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["class"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["class"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(InfoBox, {
                            title: _ctx.$t('home.location_not_found'),
                            text: _ctx.$t('home.location_not_found_details')
                          }, null, 8, ["title", "text"])
                        ]),
                        _: 1
                      }))
                    : (bubblesLoader.value === true)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 1,
                          class: "mb-12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(LoaderComponent)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_container, {
            id: "firstInfoContainer",
            class: "py-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(BannerBox, _normalizeProps(_guardReactiveProps(_ctx.$tm('banners.APHomeBannerTop'))), null, 16),
                  (!currentProvinceName.value)
                    ? (_openBlock(), _createBlock(DonorSteps, {
                        key: 0,
                        title: _unref(t)('home.homeSteps.title'),
                        steps: _unref(tm)('home.homeSteps.steps'),
                        "guide-button-text": _ctx.$t('label.showGuide')
                      }, null, 8, ["title", "steps", "guide-button-text"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (!currentProvinceName.value)
            ? (_openBlock(), _createBlock(_component_v_container, {
                key: 1,
                fluid: "",
                class: "pa-0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("section", null, [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(SlidersContainer, { class: "mb-12" })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!currentProvinceName.value)
            ? (_openBlock(), _createBlock(_component_v_container, { key: 2 }, {
                default: _withCtx(() => [
                  _createVNode(FAQPanels, { faq: homePageFaq.value }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(BaseButton, {
                          href: _unref(LINKS).guide,
                          variant: "secondary",
                          class: "home-page__faq-button mt-3 order-1 order-sm-0"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('home.faq.moreInfo')), 1)
                          ]),
                          _: 1
                        }, 8, ["href"]),
                        (_unref(isCampaignUnderway))
                          ? (_openBlock(), _createBlock(BaseButton, {
                              key: 0,
                              class: "home-page__faq-button",
                              onClick: scrollTop
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('home.faq.choosingFamily')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_unref(isAfterCampaign) || _unref(isBeforeCampaign))
                          ? (_openBlock(), _createBlock(BaseButton, {
                              key: 1,
                              href: _unref(LINKS).szpHomePage,
                              class: "home-page__faq-button"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('label.goToHomePage')), 1)
                              ]),
                              _: 1
                            }, 8, ["href"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["faq"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!currentProvinceName.value)
            ? (_openBlock(), _createBlock(_component_v_container, {
                key: 3,
                class: "mb-5"
              }, {
                default: _withCtx(() => [
                  (_unref(isCampaignUnderway))
                    ? (_openBlock(), _createBlock(InfoSectionHome, { key: 0 }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!currentProvinceName.value)
            ? (_openBlock(), _createBlock(_component_v_container, {
                key: 4,
                class: "py-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(BannerBox, _normalizeProps(_guardReactiveProps(_ctx.$tm('banners.SzPHomeBanner'))), null, 16),
                        _createVNode(BannerBox, _normalizeProps(_guardReactiveProps(_ctx.$tm('banners.APHomeBannerBottom'))), null, 16)
                      ]),
                      _createVNode(SponsorsComponent, { class: "mt-3 mb-5 w-100" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(ModalCustom, {
            modelValue: _unref(passwordPopup),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(passwordPopup) ? (passwordPopup).value = $event : null)),
            closeable: false,
            icon: false,
            divider: false
          }, {
            header: _withCtx(() => [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('home.passwordPopup')), 1),
              _createVNode(TextField, {
                modelValue: password.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
                type: "password",
                placeholder: _ctx.$t('label.code'),
                rules: "required",
                name: "password",
                "validate-on-value-update": false,
                onKeyup: _withKeys(submitPassword, ["enter"]),
                onInput: hidePasswordErrorText
              }, null, 8, ["modelValue", "placeholder"]),
              _createVNode(_component_v_btn, {
                color: "szRed",
                class: "primary-button mt-3 mb-3",
                variant: "flat",
                block: _ctx.$vuetify.display.xs,
                disabled: submitPasswordButtonDisabled.value,
                onClick: submitPassword
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('label.ok')), 1)
                ]),
                _: 1
              }, 8, ["block", "disabled"]),
              (showPasswordErrorText.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t('label.errorPassword')), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(ScrollTopButton),
          _createVNode(FooterComponent, { class: "mt-5" })
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(LoaderComponent, {
        key: 1,
        page: ""
      }))
}
}

})